/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Page_Title_DepartmentsInputs */

const en_page_title_departments = /** @type {(inputs: Page_Title_DepartmentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Departments`)
};

const nl_page_title_departments = /** @type {(inputs: Page_Title_DepartmentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afdelingen`)
};

/**
* | output |
* | --- |
* | "Departments" |
*
* @param {Page_Title_DepartmentsInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const page_title_departments = /** @type {((inputs?: Page_Title_DepartmentsInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Page_Title_DepartmentsInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_page_title_departments(inputs)
	return en_page_title_departments(inputs)
});